import { apiFetch } from './utils/api';

// eslint-disable-next-line no-unused-vars
const mockedMeetings = require('./mocks/v3/meetings.json');

export const meetings = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v3/meetings';

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
